/** "Microsoft is busy — trying again": shown (and announced) while a read waits to be tried again. */
import { useTranslation } from 'react-i18next';
import { useMicrosoftBusy } from '@/lib/busy';
import { Icon } from './Icons';

export function BusyNotice() {
  const { t } = useTranslation();
  const busy = useMicrosoftBusy();
  return (
    <div className="busy-notice" role="status" aria-live="polite" data-testid="busy-notice" data-busy={busy ? 'yes' : 'no'}>
      {busy ? (
        <span className="busy-pill">
          <Icon name="clock" />
          {t('errors.busy')}
        </span>
      ) : null}
    </div>
  );
}
